import { DashMenuOptionsProps } from '@/components/DashMenu/interfaces';
import { CancelToken } from 'axios';
import { CSSProperties } from 'react';

export enum DashboardCardTypeEnum {
  DEFAULT = 'default',
  DONUT_CHART = 'donut_chart',
  MULTIPLES_DONUTS_CHART = 'multiples_donuts_chart',
  BAR_CHART = 'bar_chart',
  PYRAMID_CHART = 'pyramid_chart',
  LINE_CHART = 'line_chart',
  BAR_LINE_CHART = 'bar_line_chart',
  RADAR_CHART = 'radar_chart',
  HEATMAP_CHART = 'heatmap_chart',
  GAUGE_CHART = 'gauge_chart',
  GAUGE_CHART_V2 = 'gauge_chart_v2',
  RESPONSIVE_LIST = 'responsive_list',
  RESPONSIVE_TABLE = 'responsive_table',
  RESPONSIVE_TABLE_TEXT = 'responsive_table_text',
  SIMPLE_TEXT = 'simple_text',
  TABLE = 'table',
  LIST = 'list',
  MAP = 'map',
  RESPONSIVE_TABLE_MULTI = 'responsive_table_multi',
  PHOTO_BOOK = 'photo_book',
  HEADER = 'header',
  TABS = 'tabs',
  FILTER_CARD = 'filter_card',
  FRAME_CARD = 'frame_card',
  BIG_CALENDAR = 'big_calendar',
  GOOGLE_MAP = 'google_map',
  GOOGLE_MAP_GENERAL_INSPECTION = 'google_maps_general_inspection',
  AREA_BUMP = 'area_bump',
  AUDIT_CARD = 'audit_card',
  TICKET_CARD = 'ticket_card',
  PROGRESS_BAR = 'progress_bar',
  MULTI_CARD = 'multi_card',
}

export interface DashboardCardProps {
  id: string;
  dashId: string;
  tabCardId?: string;
  dashMenuOptions?: DashMenuOptionsProps[];
  cancelToken: CancelToken;
  filterPanel: boolean;
  navigationPanel: boolean;
  refreshCardTimout?: Nullable<number>;
  isExportable?: boolean;
  exportTypes?: string[];
  key: string;
  type: string;
  title?: string;
  infoMaxWidth?: number;
  subtitle?: string;
  url: string;
  filters: string;
  filterGlobalForRowExport?: string;
  isSimple?: boolean;
  style?: CSSProperties;
  className?: string;
  modalMode?: boolean;
  isModal?: boolean;
  formattedFilters?: any;
  initialFilters?: any;
  isTab?: boolean;
  isMulti?: boolean;
  onMenu?: boolean;
  isImageExportable?: boolean;
  gridColumn?: string;
  gridRow?: string;
  fromMultiCard?: boolean;
  customTitle?: string;
  autoFlowId?: string;
  setFilter?: (query: string) => void;
}
